import { graphql } from 'gatsby';
import React from 'react';
// import { getSettingsClass } from '~/utils/helpers';

interface UseCasesProps {
  settings: Settings;
  use_cases_theme: 'light-blue' | 'dark-blue' | 'light-orange' | 'dark-orange';
  use_cases_padding: {
    mobile_top_bottom: number;
    mobile_left_right: number;
    desktop_top_bottom: number;
    desktop_left_right: number;
  };
  use_cases_text_size: {
    mobile: number;
    desktop: number;
  };
  use_cases: {
    title: string;
    is_highlighted: boolean;
    visibility: 'everywhere' | 'desktop' | 'mobile';
  }[];
}

/* The block to showcase use cases for different products or features */
const UseCases: React.FC<UseCasesProps> = ({
  settings,
  use_cases_theme,
  use_cases_padding,
  use_cases_text_size,
  use_cases,
}) => {
  // const settingsClass = getSettingsClass(settings);
  // Settings CSS is broken - rules are missing for padding and margin
  return (
    <div className={`block__use_cases`}>
      <div
        className={`use-cases use-cases--${use_cases_theme}`}
        style={
          {
            '--font-size-mobile_': `${use_cases_text_size.mobile}rem`,
            '--font-size-desktop': `${use_cases_text_size.desktop}rem`,
          } as React.CSSProperties
        }
      >
        {use_cases.map((use_case, index) => {
          const stateClass = use_case.is_highlighted ? ' highlighted' : '';
          const visibilityClass =
            use_case.visibility === 'everywhere'
              ? ''
              : ` visible--${use_case.visibility}`;
          return (
            <div
              key={index}
              className={`use-case${stateClass}${visibilityClass}`}
              style={
                {
                  '--padding-mobile-top-bottom': `${use_cases_padding.mobile_top_bottom}rem`,
                  '--padding-mobile-left-right': `${use_cases_padding.mobile_left_right}rem`,
                  '--padding-desktop-top-bottom': `${use_cases_padding.desktop_top_bottom}rem`,
                  '--padding-desktop-left-right': `${use_cases_padding.desktop_left_right}rem`,
                } as React.CSSProperties
              }
            >
              <span>{use_case.title}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UseCases;

export const useCasesFragment = graphql`
  fragment UseCasesFragment on Block {
    settings {
      ...SettingsFragment
    }
    use_cases_theme
    use_cases_padding {
      mobile_top_bottom
      mobile_left_right
      desktop_top_bottom
      desktop_left_right
    }
    use_cases_text_size {
      mobile
      desktop
    }
    use_cases {
      title
      is_highlighted
      visibility
    }
  }
`;
